<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Request Job'"
      [canGoBack]="true"
      [customBack]="customBackPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-wrapper-scroll' : ''">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (loaded) {
      <!--<ng-container *ngIf="!hasPros && waterfallSettings?.key == 'never_use_tidy'">
      <tidy-alert>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image
            [src]="'assets/img/alert.svg'"
            class="header-size">
          </tidy-image>
          <tidy-text
            [header]="'Unable to Book'">
          </tidy-text>
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'You don\'t allow new pros and haven\'t added any of your new pros for this service type. Please enable TIDY Find New Pros or add your own pros to book.'">
          </tidy-text>
        </tidy-row>
        <tidy-row>
          <tidy-button
            [text]="'Allow TIDY Find New Pros'"
            [action]="boundTurnOnTidyFindNewPros"
            class="primary">
          </tidy-button>
        </tidy-row>
        <tidy-row>
          <tidy-button
            [text]="'Add Pros'"
            [action]="boundGoToAddPro"
            class="secondary">
          </tidy-button>
        </tidy-row>
      </tidy-alert>
    </ng-container>-->
    @if (customFlowName) {
      <tidy-alert style="padding: 15px 15px 15px 5px">
        <tidy-grid>
          <tidy-row>
            <ion-row>
              <ion-col size="2" class="vertical-align-center">
                <div style="margin:auto">
                  <tidy-image
                    [src]="customFlowSmallImage"
                    style="width: 50px" />
                </div>
              </ion-col>
              <ion-col>
                <div style="margin-top: 5px">
                  <tidy-text
                    [body]="customFlowName" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'offers a'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="customFlowDiscount" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="'% discount on all cleanings.'" />
                      </div>
                    </ion-col>
                  </ion-row>
                </tidy-row>
              </tidy-grid>
            </tidy-alert>
          }
          <ng-container>
            @for (service of services; track service; let i = $index) {
              @if (showService(service)) {
                <tidy-card>
                  <form [formGroup]="form" novalidate action="#">
                    <tidy-card-button [hideArrow]="true" (action)="handleServiceClick(service)">
                      <tidy-row class="position-relative">
                        <tidy-row>
                          <tidy-radio-button
                            formControlName="service"
                            class="radio-card-title"
                            [form]="form.controls.service"
                            (optionChange)="serviceChange()"
                            [items]="[{value: service.key, viewValue: service.title | titlecase}]" />
                        </tidy-row>
                        @if (!hasPrivatePros && !hasNoPrivatePros || !hasPrivatePros && hasNoPrivatePros) {
                          <tidy-row>
                            <ion-row>
                              <ion-col size="10">
                                <tidy-text
                                  [body]="bookJobService.getDisplayPriceForJob(planId, service, selectedFrequency, true, bookingType, hasNonTrialPaidSubscription, priceExperiment, bookingExperiment, customFlowName, false) + ' - '" />
                                <tidy-text
                                  [body]="service.description" />
                              </ion-col>
                            </ion-row>
                          </tidy-row>
                        }
                      </tidy-row>
                      @if (form.value.service === service.key) {
                        <tidy-row class="extra-top-padding extra-bottom-padding">
                          <tidy-divider />
                        </tidy-row>
                        <form [formGroup]="form" novalidate action="#">
                          <tidy-row class="field-bottom-padding">
                            <tidy-select
                              [label]="'Frequency'"
                              [icon]="'assets/svg/time.svg'"
                              [form]="form.controls.frequency"
                              formControlName="frequency"
                              [items]="frequencyItems" />
                          </tidy-row>
                          <tidy-row class="field-bottom-padding">
                            <tidy-text
                              [header]="'Earliest Start'" />
                          </tidy-row>
                          <tidy-row>
                            <tidy-two-column-row>
                              <tidy-datepicker
                                #noEarlierDate
                                style="padding-right:10px"
                                [label]="'Date'"
                                [icon]="'assets/svg/calendar.svg'"
                                formControlName="noEarlierDate"
                                [form]="form.controls.noEarlierDate"
                                errorMessage="Please enter a date."
                                [noPastDates]="true"
                                (optionChange)="earlierDateChange($event)"
                                [submitted]="submitted" />
                              <tidy-select
                                [icon]="'assets/svg/time.svg'"
                                [label]="'Time'"
                                [items]="noEarlierTimes"
                                [form]="form.controls.noEarlierTime"
                                formControlName="noEarlierTime"
                                (optionChange)="selectNoEarlierTime($event)"
                                errorMessage="Please enter a time."
                                [hideSearch]="true"
                                [submitted]="submitted" />
                            </tidy-two-column-row>
                          </tidy-row>
                          @if (tooFarStartDateError) {
                            <tidy-error-message
                              [text]="'Please select an earliest start date no more than 3 days before the latest finish date.'" />
                          }
                          <tidy-row class="extra-top-padding field-bottom-padding">
                            <tidy-text
                              [header]="'Latest Finish'" />
                          </tidy-row>
                          <tidy-row>
                            <tidy-two-column-row>
                              <tidy-datepicker
                                style="padding-right:10px"
                                [label]="'Date'"
                                [icon]="'assets/svg/calendar.svg'"
                                formControlName="noLaterDate"
                                [form]="form.controls.noLaterDate"
                                errorMessage="Please enter a date."
                                [minDate]="form.controls.noEarlierDate.value"
                                (optionChange)="updateNoLaterOpts()"
                                [submitted]="submitted" />
                              <tidy-select
                                [icon]="'assets/svg/time.svg'"
                                [label]="'Time'"
                                [items]="noLaterTimes"
                                [form]="form.controls.noLaterTime"
                                formControlName="noLaterTime"
                                (optionChange)="selectNoLaterTime($event)"
                                errorMessage="Please enter a time."
                                [hideSearch]="true"
                                [submitted]="submitted" />
                            </tidy-two-column-row>
                          </tidy-row>
                          @if (tooFarEndDateError) {
                            <tidy-error-message
                              [text]="'Please select a latest finish date no more than 3 days after the earliest start date.'" />
                          }
                          @if (showTimesError) {
                            <tidy-row class="extra-top-padding">
                              <tidy-text
                                [body]="'<b>Note:</b> TIDY\'s Find New Pros feature only works for start times of 8:00am or later, end times of 11:00pm or earlier, and at least'" /><span>&nbsp;</span>
                                <tidy-text
                                  [body]="getTimesErrorText()" />
                              </tidy-row>
                            }
                            @if (forms) {
                              <dynamic-booking-form
                                #dynamicBookingForm
                                [forms]="forms"
                                [submitted]="submitted"
                                [hasImageUploadError]="hasImageUploadError"
                                [isLoading]="isLoadingDynamicForm"
                                (attachmentsChange)="onAttachmentsChange($event)"
                                (selectedCheckboxesChange)="onSelectedCheckboxesChange($event)"
                                (formDataChange)="onFormDataChange($event)" />
                            }
                            <!-- Job Notes Section -->
                            <tidy-row
                              [class]="forms?.[0]?.inputs?.length ? 'extra-top-padding' : ''">
                              <form [formGroup]="form" novalidate action="#">
                                <tidy-textarea
                                  formControlName="jobNote"
                                  [form]="form.controls.jobNote"
                                  label="Job Note"
                                  [icon]="'assets/svg/information-circle.svg'"
                                  placeholder="Enter any special instructions or notes for this job..." />
                              </form>
                            </tidy-row>
                            <tidy-row>
                              <tidy-text
                                [helper]="'Add notes for this job to convey general instructions to your pro.'"
                                class="small-text" />
                            </tidy-row>
                          </form>
                        }
                      </tidy-card-button>
                    </form>
                  </tidy-card>
                }
              }
              @if (didChooseService && !showMoreServices && services?.length > 1) {
                <tidy-row [align]="'center'" class="extra-bottom-padding">
                  <tidy-text
                    (action)="showServices()"
                    [body]="'Show More Services'"
                    class="white-link" />
                </tidy-row>
              }
              @if ((showSameDayTimeAlert && (!hasPrivatePros && !hasNoPrivatePros || hasNoPrivatePros && !hasPrivatePros)) || (hasPrivatePros && windowService.isDesktopRes)) {
                <tidy-alert>
                  @if (showSameDayTimeAlert && (!hasPrivatePros && !hasNoPrivatePros || hasNoPrivatePros && !hasPrivatePros)) {
                    <tidy-row>
                      <tidy-text
                        [body]="'<b>Note:</b> You selected times today. If a Pro accepts a time today from Find New Pros <u>the price will be +50%.</u>'" />
                    </tidy-row>
                  }
                  @if (hasPrivatePros && windowService.isDesktopRes) {
                    <tidy-row>
                      <tidy-text
                        [body]="'You can manage your pro pricing in the pro settings section.'" />
                      <tidy-text
                        [body]="'Manage Pros'"
                        class="link"
                        (action)="goToProsSettings()" />
                    </tidy-row>
                  }
                </tidy-alert>
              }
              @if (!windowService?.isDesktopRes || isRightSideContent) {
                <tidy-card class="ai-gradient-border">
                  <tidy-row [align]="'center'" class="extra-bottom-padding">
                    <tidy-text [header]="'Acceptance Probability'" />
                  </tidy-row>
                  @if (!didSelectAllTimes) {
                    <tidy-row [align]="'center'" class="extra-bottom-padding">
                      <tidy-text [body]="'Select all times to see the estimated chance that a pro accepts your job.'" />
                    </tidy-row>
                  }
                  @if (didSelectAllTimes && probabilityData) {
                    <tidy-row [align]="'center'" class="extra-bottom-padding">
                      <tidy-text [body]="'Pro Search Agent estimates a '" />
                      <tidy-text [body]="probabilityData?.acceptance_probability + '%'" style="font-weight: bold;" />
                      <tidy-text [body]="' chance of a pro accepting.'" /><span>&nbsp;</span>
                      <tidy-text [actionBody]="'Learn More'" class="white-link" (action)="goToLearnMoreProbability()" />
                    </tidy-row>
                    @if (probabilityData?.acceptance_probability <= 98 && probabilityData?.factors?.length) {
                      <tidy-row [align]="'center'" class="extra-bottom-padding">
                        <tidy-text [body]="'To improve:'" />
                      </tidy-row>
                      <tidy-row style="display: flex; flex-direction: row; justify-content: center; flex-wrap: wrap;" [align]="'center'">
                        @for (factor of probabilityData?.factors; track factor) {
                          <tidy-card style="display: inline-block; width: auto; margin-right: 10px; margin-bottom: 10px;">
                            <tidy-row [align]="'center'">
                              <tidy-text [body]="factor?.factor" />
                            </tidy-row>
                          </tidy-card>
                        }
                      </tidy-row>
                    }
                  }
                </tidy-card>
              }
                  @if (errorMessage) {
                    <tidy-error-message
                      [text]="errorMessage" />
                  }
                  <tidy-button
                    [text]="'Review Request'"
                    [action]="boundSubmit"
                    class="primary" />
                  @if (priorityListSentence !== 'Pros that you\'ve added or had jobs with will appear here.') {
                    <tidy-alert>
                      <tidy-row class="extra-bottom-padding">
                        <tidy-text
                          [header]="'How Job Requests Work:'" />
                      </tidy-row>
                      <tidy-row class="extra-bottom-padding">
                        <tidy-text
                          [body]="priorityListSentence" />
                      </tidy-row>
                      <tidy-row>
                        <tidy-text
                          [body]="'We\'ll notify you right away if someone accepts.'" />
                      </tidy-row>
                    </tidy-alert>
                  }
                </ng-container>
              }
            </tidy-wrapper>
          </ng-template>

          <ng-template #rightColumn>
            @if (loaded && windowService.isDesktopRes) {
              <tidy-card class="ai-gradient-border" style="margin: 10px;">
                <tidy-row [align]="'center'" class="extra-bottom-padding">
                  <tidy-text [header]="'Acceptance Probability'" />
                </tidy-row>
                @if (!didSelectAllTimes) {
                  <tidy-row [align]="'center'">
                    <tidy-text [body]="'Select all times to see the estimated chance that a pro accepts your job.'" />
                  </tidy-row>
                }
                @if (didSelectAllTimes && probabilityData) {
                  <tidy-row [align]="'center'" class="extra-bottom-padding">
                    <tidy-text [body]="'Pro Search Agent estimates a '" />
                    <tidy-text [body]="probabilityData?.acceptance_probability + '%'" style="font-weight: bold;" />
                    <tidy-text [body]="' chance of a pro accepting.'" /><span>&nbsp;</span>
                    <tidy-text [actionBody]="'Learn More'" class="white-link" (action)="goToLearnMoreProbability()" />
                  </tidy-row>
                  @if (probabilityData?.acceptance_probability <= 98 && probabilityData?.factors?.length) {
                    <tidy-row [align]="'center'" class="extra-bottom-padding">
                      <tidy-text [body]="'To improve:'" />
                    </tidy-row>
                    <tidy-row style="display: flex; flex-direction: row; justify-content: center; flex-wrap: wrap;" [align]="'center'">
                      @for (factor of probabilityData?.factors; track factor) {
                        <tidy-card style="display: inline-block; width: auto; margin-right: 10px; margin-bottom: 10px;">
                          <tidy-row [align]="'center'">
                            <tidy-text [body]="factor?.factor" />
                          </tidy-row>
                        </tidy-card>
                      }
                    </tidy-row>
                  }
                }
              </tidy-card>
            }
          </ng-template>

              @if (!isRightSideContent) {
                <div>
                  <app-scroll-wrapper [widerRightColumn]="true" [templateRightColumn]="rightColumn" [templateContent]="content" />
                </div>
              }

              @if (isRightSideContent) {
                <ion-content class="ion-content-right-column">
                  <ng-container *ngTemplateOutlet="content" />
                </ion-content>
              }
